import { useEffect, useState } from 'react';
import { Alert, Button, Card, Col, Container, Form, ListGroup, ListGroupItem, Modal, OverlayTrigger, Row, Table, Tooltip } from 'react-bootstrap';
import { At, Book, BoxArrowRight, Building, CalendarCheck, CheckCircle, Clock, ExclamationCircleFill, ExclamationDiamond, FileEarmarkCheck, Megaphone, PersonCircle, Phone, PhoneFill, PinMapFill, ShieldCheck, TelephoneFill, Whatsapp } from 'react-bootstrap-icons';
import { Redirect } from 'react-router-dom';
import Select from 'react-select';

import LinkGoogle from '../components/LinkGoogle';
import NavBar from '../components/Navbar';

import { getLocalidades, getLocalidade } from '../services/api';

function Gpr({ getToken, logoff, modulo }) {

  if (!modulo) {
    modulo = "GPR";
  }

  const [zonas, setZonas] = useState(false);
  const [postos, setPostos] = useState(false);
  const [mensagem, setMensagem] = useState(false);

  const [semAtendimento, setSemAtendimento] = useState(false);

  const [localidades, setLocalidades] = useState(['Teste', 'Teste']);
  const [isLoading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const [eleitorado, setEleitorado] = useState(false);
  const [secoes, setSecoes] = useState(false);
  const [locais, setLocais] = useState(false);

  const [modalData, setModalData] = useState(false);

  const [showModalRotas, setShowModalRotas] = useState(false);
  const [modalDataRotas, setDataModalRotas] = useState(false);

  const [gprLinks, setGprLinks] = useState({});

  const onCloseModal = () => {
    setShowModal(false);
    setModalData(false);
  }

  // const onOpenModal = (data) => {
  //   setShowModal(true);
  //   setModalData(data);
  // }

  const onCloseModalRotas = () => {
    setShowModalRotas(false);
  }

  const onOpenModalRotas = () => {
    setShowModalRotas(true);
  }

  const exitApp = () => {
    logoff();
    window.location.reload();
  }

  useEffect(() => {
    getLocalidades(modulo).then(result => {
      setLocalidades(result.data)
      setLoading(false)
    })
  }, [modulo]);

  const loadData = (localidade) => {
    setLoading(true)
    getLocalidade(localidade, modulo).then(result => {
      if (result.data.sucesso) {
        console.log(result);

        setPostos(result.data.postos);
        setZonas(result.data.zonas);
        setMensagem(result.data.mensagem);
        setEleitorado(result.data.eleitorado.toLocaleString('pt-BR'));
        setSecoes(result.data.secoes);
        setLocais(result.data.locais);
        setGprLinks(result.data.links);
        if (modulo === "GPRF") setDataModalRotas(result.data.rotas)
      } else {
        setSemAtendimento(true)
      }
      setLoading(false);
    })
  }

  let subsubtitle = "GPR Eleições 2026";

  if (modulo === "GPRF") {
    subsubtitle = "GPR Forças 2026";
  }

  if (!getToken()) {
    return (
      <Redirect to="/consulta-contatos-web/" />
    )
  }

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Sair
    </Tooltip>
  );

  return (
    <>
      <NavBar title="Dados Eleitorais" subtitle="" subsubtitle={subsubtitle} modulo={modulo} />
      <Container>

        <Row style={{ marginTop: 120 }}>
          <Col xs={12} sm={12} md={12} lg={12} className="mx-auto" >
            <Card style={{ paddingLeft: 15, paddingRight: 15, paddingTop: 10, paddingBottom: 10 }}>
              <OverlayTrigger delay={{ show: 250, hide: 400 }} overlay={renderTooltip}>
                <span style={{ fontSize: 20, color: '#007bff', cursor: 'pointer', position: 'absolute', right: 20 }} onClick={exitApp} tooltip="Sair"><BoxArrowRight /></span>
              </OverlayTrigger>
              <Form.Group>
                <Form.Label style={{ fontWeight: 'bold' }}>
                  Selecione o município:
                </Form.Label>
                <Select
                  autoFocus={true}
                  className="basic-single"
                  classNamePrefix="select"
                  isLoading={isLoading}
                  isDisabled={isLoading}
                  isClearable={true}
                  isSearchable={true}
                  placeholder="Digite a localidade..."
                  onChange={(obj) => { setLoading(false); loadData(obj) }}
                  name="color"
                  id="teste"
                  options={localidades}
                />
              </Form.Group>

              {!isLoading && eleitorado && (
                <Row style={{ marginTop: 15 }}>
                  <Col className="mx-auto" >
                    <Row>

                      <Col>
                        <div className="notice notice-info">
                          <strong>Locais de Votação</strong><br />
                          <span style={{ fontSize: "2em", fontWeight: "bold" }}>{new Intl.NumberFormat('pt-BR', { style: 'decimal' }).format(locais)}</span>
                        </div>
                      </Col>

                      <Col>
                        <div className="notice notice-info">
                          <strong>Seções</strong><br />
                          <span style={{ fontSize: "2em", fontWeight: "bold" }}>{new Intl.NumberFormat('pt-BR', { style: 'decimal' }).format(secoes)}</span>
                        </div>
                      </Col>

                      <Col>
                        <div className="notice notice-success">
                          <strong>Eleitorado</strong><br />
                          <span style={{ fontSize: "2em", fontWeight: "bold" }}>{new Intl.NumberFormat('pt-BR', { style: 'decimal' }).format(eleitorado)}</span>
                        </div>
                      </Col>

                      {
                        modalDataRotas?.length && (
                          <Col>
                            <div className="notice notice-success" style={{ display: "flex", flexDirection: "column" }}>
                              <strong style={{ marginTop: -8 }}>Rotas</strong>
                              <span style={{ fontSize: "2em", fontWeight: "bold", marginTop: -5 }}>{modalDataRotas?.length} </span><span style={{ color: '#007bff', cursor: 'pointer', marginTop: -11, fontSize: 15 }} onClick={onOpenModalRotas}>  <span style={{ paddingTop: 20 }}>Mais Informações</span></span>
                            </div>
                          </Col>
                        )
                      }

                    </Row>
                  </Col>
                </Row>
              )
              }


            </Card>
          </Col>
        </Row>

        {!isLoading && semAtendimento &&
          (
            <Row style={{ marginTop: 15 }}>
              <Col md={6} className="mx-auto">
                <Alert variant="info" className="text-center">
                  Não encontramos atendimento para sua localização. Tente outro município.
                </Alert>
              </Col>
            </Row>
          )
        }

        {!isLoading && mensagem && mensagem.map(mm => {
          return (
            <Row style={{ marginTop: 10 }} key={mm.id}>
              <Col md={6} className="mx-auto">
                <Alert variant="warning" className="text-center">
                  <b><ExclamationCircleFill /> Atenção {mm.zona}ª Zona Eleitoral</b>
                  <hr />
                  {mm.mensagem}
                </Alert>
              </Col>
            </Row>
          )
        })
        }

        {!isLoading && postos && postos.map(posto => {
          return (
            <Row style={{ marginTop: 15 }} key={posto.id}>
              <Col md={12} className="mx-auto">
                <Card sm={12} style={{ marginBottom: 20, borderRadius: 10 }} className="shadow-sm" >
                  <Card.Header style={{ backgroundColor: "#596f99", color: "#fff" }}>
                    <Card.Title style={{ marginBottom: 0 }}>{posto.nome}</Card.Title>
                  </Card.Header>
                  <Card.Body >

                    <Card.Text>
                      <span>
                        <TelephoneFill />  {posto.telefone ? (<a href={"tel:" + posto.telefone.replace(/\D/g, '')}>{posto.telefone}</a>) : ''} <br />
                      </span>
                      <span style={{ marginTop: 25, lineHeight: 1 }}>
                        <PhoneFill />  {posto.fax ? (<a href={"tel:" + posto.fax.replace(/\D/g, '')}><b>{posto.fax}</b></a>) : ('Não Informado')} <br />
                      </span>
                      <br />
                      <span style={{ marginTop: 25, lineHeight: 1 }}>
                        <Whatsapp />  Tire suas dúvidas no <a target='_blank' rel="noreferrer" href={gprLinks.chatbotJE.link}>{gprLinks.chatbotJE.label}</a><br />
                      </span>
                      <span style={{ marginTop: 25, lineHeight: 1 }}>
                        <TelephoneFill />  <b><a href={gprLinks.disqueEleitor.link}>{gprLinks.disqueEleitor.label}</a></b> (Disque-Eleitor / Segunda a Sexta-feira, das 13h às 19h) <br />
                      </span>

                      <br />
                      <span style={{ marginTop: 25, lineHeight: 1 }}>
                        <LinkGoogle endereco={posto.endereco} municipio={posto.municipio} cep={posto.cep} />
                      </span>

                    </Card.Text>
                    {
                      posto.observacao ? (
                        <p className="text-center" style={{ marginTop: 15, backgroundColor: '#cff4fc', borderColor: '#b6effb' }}>
                          <b>Atenção:</b>
                          <br />
                          {posto.observacao}
                        </p>
                      ) : null
                    }
                  </Card.Body>
                  <ListGroup className="list-group-flush">
                    {
                      posto.zona_responsavel ? <ListGroupItem style={{ padding: 5, paddingLeft: 20 }}> <Building />  {posto.zona_responsavel}ª Zona Eleitoral <br /><span style={{ marginLeft: 20, fontSize: '0.8em', fontStyle: 'italic' }}>Zona Eleitoral Responsável</span></ListGroupItem> : ''
                    }
                    {
                      posto.chefe_responsavel ? <ListGroupItem style={{ padding: 5, paddingLeft: 20 }}> <PersonCircle />  {posto.chefe_responsavel} <br /><span style={{ marginLeft: 20, fontSize: '0.8em', fontStyle: 'italic' }}>Chefe do Cartório Responsável</span></ListGroupItem> : ''
                    }
                  </ListGroup>
                  <Card.Footer className='text-right' style={{ fontSize: 10, fontStyle: "italic" }}>
                    Atualizado em: {new Date().toLocaleDateString('pt-BR')}
                  </Card.Footer>
                </Card>
              </Col>
            </Row>
          )
        })
        }

        {!isLoading && zonas && zonas.map(zona => {
          return (
            <Row style={{ marginTop: 10 }} key={zona.id}>
              <Col md={12} className="mx-auto">
                <Card sm={12} style={{ marginBottom: 20, borderRadius: 10 }} className="shadow-sm" >
                  <Card.Header style={{ backgroundColor: "#596f99", color: "#fff" }}>
                    <Card.Title style={{ marginBottom: 0, textTransform: "uppercase" }}>{zona.nome} - <span>{zona.sede}</span></Card.Title>
                  </Card.Header>
                  <Card.Body >
                    {
                      zona.observacao ? (
                        <p className="text-center" style={{ marginTop: 15, backgroundColor: '#cff4fc', borderColor: '#b6effb' }}>
                          <b>Atenção:</b>
                          <br />
                          {zona.observacao}
                        </p>
                      ) : null
                    }
                    <Card.Text>
                      <span>
                        <PinMapFill />  Jurisdição <span style={{ fontSize: '0.8em', marginLeft: 22, textAlign: "justify" }} dangerouslySetInnerHTML={{ __html: zona.jurisdicao }}></span><br />
                      </span>
                      <span>
                        <Clock />  <b>{zona.atendimento ?? 'Não Informado'}</b><br />
                      </span>
                      <span>
                        <TelephoneFill /> {zona.telefone ? (<a href={"tel:" + zona.telefone.replace(/\D/g, '')}><b>{zona.telefone}</b></a>) : ('Não Informado')}
                        {zona.telefone2 ? (<> / <a href={"tel:" + zona.telefone2.replace(/\D/g, '')}><b>{zona.telefone2}</b></a></>) : ('')} <br />
                      </span>
                      <span style={{ marginTop: 25, lineHeight: 1 }}>
                        <Phone />  {zona.fax ? (<a href={"tel:" + zona.fax.replace(/\D/g, '')}><b>{zona.fax}</b></a>) : ('Não Informado')} <br />
                      </span>
                      <br />
                      <LinkGoogle endereco={zona.endereco} municipio={zona.municipio} cep={zona.cep} />
                      <br />
                      <span >
                        <At /> <a href={"mailto:" + zona.email}>{zona.email}</a> <br />
                      </span>

                    </Card.Text>
                  </Card.Body>
                  <ListGroup className="list-group-flush">

                    {
                      zona.juiz &&
                      (<ListGroupItem style={{ padding: 5, paddingLeft: 20 }}>
                        <PersonCircle /> {zona.juiz} {zona.telefoneJuiz ? (<img className='img-fluid cc imgfon' src={`data:image/svg+xml;utf8,${zona.telefoneJuiz}`} alt="" />) : ""} <br />
                        <span style={{ marginLeft: 20, fontSize: '0.8em', fontStyle: 'italic' }}>Juiz Eleitoral</span>
                      </ListGroupItem>)
                    }
                    {
                      zona.promotor &&
                      (<ListGroupItem style={{ padding: 5, paddingLeft: 20 }}>
                        <PersonCircle />  {zona.promotor} {zona.telefonePromotor ? (<img className='img-fluid cc imgfon' src={`data:image/svg+xml;utf8,${zona.telefonePromotor}`} alt="" />) : ""} <br />
                        <span style={{ marginLeft: 20, fontSize: '0.8em', fontStyle: 'italic' }}>Promotor Eleitoral</span>
                      </ListGroupItem>)
                    }
                    {
                      zona.chefe &&
                      (<ListGroupItem style={{ padding: 5, paddingLeft: 20 }}>
                        <PersonCircle />  {zona.chefe} {zona.telefoneChefe ? (<img className='img-fluid cc imgfon' src={`data:image/svg+xml;utf8,${zona.telefoneChefe}`} alt="" />) : ""} <br />
                        <span style={{ marginLeft: 20, fontSize: '0.8em', fontStyle: 'italic' }}>Chefe do Cartório</span>
                      </ListGroupItem>)
                    }




                    {modulo === "GPR" &&
                      (<>
                        <ListGroupItem style={{ padding: 5, paddingLeft: 20 }}>
                          <CheckCircle /> <span style={{ fontWeight: "bold" }}> Apoio</span>
                          <ul style={{ listStyle: 'none', paddingInlineStart: 20 }}>
                            <li>- <a target='_blank' rel="noreferrer" href={gprLinks.dadosEleitorais.link}>{gprLinks.dadosEleitorais.label}</a></li>
                            <li>- <a target='_blank' rel="noreferrer" href={gprLinks.guiaRapidoForcas.link}>{gprLinks.guiaRapidoForcas.label}</a></li>
                            <li>- <a target='_blank' rel="noreferrer" href={gprLinks.fatoOuBoato.link}>{gprLinks.fatoOuBoato.label}</a></li>
                            <li>- <a target='_blank' rel="noreferrer" href={gprLinks.desinformacao.link}>{gprLinks.desinformacao.label}</a></li>
                            <li>- <a target='_blank' rel="noreferrer" href={gprLinks.mapaApoio.link}>{gprLinks.mapaApoio.label}</a></li>
                          </ul>
                        </ListGroupItem>
                      </>)}

                    {modulo === "GPRF" &&
                      (<>  <ListGroupItem style={{ padding: 5, paddingLeft: 20 }}>
                        <CalendarCheck style={{ marginRight: 5 }} />
                        <a target='_blank' rel="noreferrer" href={gprLinks.cerimonias.link}>{gprLinks.cerimonias.label}</a>
                      </ListGroupItem>
                        <ListGroupItem style={{ padding: 5, paddingLeft: 20 }}>
                          <ShieldCheck /> <span style={{ fontWeight: "bold" }}> Forças de Segurança</span>
                          <ul style={{ listStyle: 'none', paddingInlineStart: 20 }}>
                            <li>- <a target='_blank' rel="noreferrer" href={gprLinks.cartilha.link}>{gprLinks.cartilha.label}</a></li>
                            <li>- <a target='_blank' rel="noreferrer" href={gprLinks.folder.link}>{gprLinks.folder.label}</a></li>
                            <li>- <a target='_blank' rel="noreferrer" href={gprLinks.folheto.link}>{gprLinks.folheto.label}</a></li>
                          </ul>
                        </ListGroupItem>
                      </>)}

                    {modulo === "GPRF" &&
                      (<ListGroupItem style={{ padding: 5, paddingLeft: 20 }}>
                        <FileEarmarkCheck /> <span style={{ fontWeight: "bold" }}> Documentos</span>
                        <Container>
                          <Row>
                            <Col>
                              <div style={{ paddingTop: 10 }}>
                                <b style={{ paddingLeft: 18 }}>Gabinete de Pronta Resposta (GPR) </b>
                                <ul style={{ listStyle: 'none', paddingInlineStart: 20 }}>
                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.portariaGpr.link}>{gprLinks.portariaGpr.label}</a></li>
                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.clima.link}>{gprLinks.clima.label}</a></li>
                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.sinalGestao.link}>{gprLinks.sinalGestao.label}</a></li>
                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.sinalConsulta.link}>{gprLinks.sinalConsulta.label}</a></li>
                                </ul>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <div style={{ paddingTop: 10 }}>
                                <b style={{ paddingLeft: 18 }}>Polícia Rodoviária Federal </b>
                                <ul style={{ listStyle: 'none', paddingInlineStart: 20 }}>
                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.portariaPRF.link}>{gprLinks.portariaPRF.label}</a></li>
                                </ul>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <div style={{ paddingTop: 10 }}>
                                <b style={{ paddingLeft: 18 }}>Cartilhas da Meta</b>
                                <ul style={{ listStyle: 'none', paddingInlineStart: 20 }}>
                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.cartilhaMetaAnuncios.link}>{gprLinks.cartilhaMetaAnuncios.label}</a></li>
                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.cartilhaMetaContencioso.link}>{gprLinks.cartilhaMetaContencioso.label}</a></li>
                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.cartilhaMetaInteligenciaArtificial.link}>{gprLinks.cartilhaMetaInteligenciaArtificial.label}</a></li>
                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.cartilhaMetaNotasFiscais.link}>{gprLinks.cartilhaMetaNotasFiscais.label}</a></li>
                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.cartilhaMetaWhatsApp.link}>{gprLinks.cartilhaMetaWhatsApp.label}</a></li>
                                </ul>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <div style={{ paddingTop: 10 }}>
                                <b style={{ paddingLeft: 18 }}>Guias da Anatel</b>
                                <ul style={{ listStyle: 'none', paddingInlineStart: 20 }}>
                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.guiaAnatelBloqueioSites.link}>{gprLinks.guiaAnatelBloqueioSites.label}</a></li>
                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.guiaAnatelBloqueiosIlicitos.link}>{gprLinks.guiaAnatelBloqueiosIlicitos.label}</a></li>
                                </ul>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <div style={{ paddingTop: 10 }}>
                                <b style={{ paddingLeft: 18 }}>Documentos do TRE-SC</b>
                                <ul style={{ listStyle: 'none', paddingInlineStart: 20 }}>

                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.despachoWindBanners.link}>{gprLinks.despachoWindBanners.label}</a></li>


                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.windBanner.link}>{gprLinks.windBanner.label}</a></li>

                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.assedio.link}>{gprLinks.assedio.label}</a></li>

                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.candidatos.link}>{gprLinks.candidatos.label}</a></li>
                                </ul>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <div style={{ paddingTop: 10 }}>
                                <b style={{ paddingLeft: 18 }}>Guia do TSE</b>
                                <ul style={{ listStyle: 'none', paddingInlineStart: 20 }}>
                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.guiaTseDecisoesRemocaoBloqueio.link}>{gprLinks.guiaTseDecisoesRemocaoBloqueio.label}</a></li>
                                </ul>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <div style={{ paddingTop: 10 }}>
                                <b style={{ paddingLeft: 18 }}>Ofícios para Órgãos Públicos</b>
                                <ul style={{ listStyle: 'none', paddingInlineStart: 20 }}>
                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.oficioGmfTransitoAdolfoMello.link}>{gprLinks.oficioGmfTransitoAdolfoMello.label}</a></li>
                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.oficioSecMunInfraestruturaTransito.link}>{gprLinks.oficioSecMunInfraestruturaTransito.label}</a></li>
                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.oficioTjscApoioSeguranca.link}>{gprLinks.oficioTjscApoioSeguranca.label}</a></li>

                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.oficio2192026.link}>{gprLinks.oficio2192026.label}</a></li>

                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.oficio8629709.link}>{gprLinks.oficio8629709.label}</a></li>

                                  <li>- <a target='_blank' rel="noreferrer" href={gprLinks.despacho11159318.link}>{gprLinks.despacho11159318.label}</a></li>

                                </ul>
                              </div>
                            </Col>
                          </Row>
                        </Container>
                      </ListGroupItem>
                      )}

                    <ListGroupItem style={{ padding: 5, paddingLeft: 20 }}>
                      <Megaphone /> <span style={{ fontWeight: "bold" }}> Denúncias</span>
                      <ul style={{ listStyle: 'none', paddingInlineStart: 20 }}>
                        <li>- Pardal: <a target='_blank' rel="noreferrer" href={gprLinks.pardal.appleStore.link}>{gprLinks.pardal.appleStore.label}</a> e <a target='_blank' rel="noreferrer" href={gprLinks.pardal.playStore.link} >{gprLinks.pardal.playStore.label}</a></li>
                      </ul>
                    </ListGroupItem>

                    <ListGroupItem style={{ padding: 5, paddingLeft: 20 }}>
                      <ExclamationDiamond /><span style={{ fontWeight: "bold" }}> Saiba Mais:</span>
                      <ul style={{ listStyle: 'none', paddingInlineStart: 10 }}>
                        {modulo === "GPRF" && (<li>- <a target='_blank' rel="noreferrer" href={gprLinks.dadosEleitorais.link}>{gprLinks.dadosEleitorais.label}</a></li>)}
                        <li>- <a target='_blank' rel="noreferrer" href={gprLinks.mesarios.link}>{gprLinks.mesarios.label}</a></li>
                        <li>- <a target='_blank' rel="noreferrer" href={gprLinks.simuladorUrna.link}>{gprLinks.simuladorUrna.label}</a></li>
                        <li>- <a target='_blank' rel="noreferrer" href={gprLinks.chatbotJE.link}>{gprLinks.chatbotJE.label}</a></li>
                        <li>- Disque-Eleitor: <a rel="noreferrer" href={gprLinks.disqueEleitor.link}>{gprLinks.disqueEleitor.label}</a></li>
                        <li>- e-Título: <a target='_blank' rel="noreferrer" href={gprLinks.etitulo.appleStore.link}>{gprLinks.etitulo.appleStore.label}</a> e <a target='_blank' rel="noreferrer" href={gprLinks.etitulo.playStore.link} >{gprLinks.etitulo.playStore.label}</a></li>
                      </ul>
                    </ListGroupItem>

                    <ListGroupItem style={{ padding: 5, paddingLeft: 20 }}>
                      <Book /><span style={{ fontWeight: "bold" }}> Biblioteca:</span>
                      <ul style={{ listStyle: 'none', paddingInlineStart: 10 }}>
                        <li>- <a target='_blank' rel="noreferrer" href={gprLinks.linktreeTresc.link}>{gprLinks.linktreeTresc.label}</a></li>
                        <li>- <a target='_blank' rel="noreferrer" href={gprLinks.catalogoPublicacoes.link}>{gprLinks.catalogoPublicacoes.label}</a></li>
                      </ul>
                    </ListGroupItem>

                  </ListGroup>

                  <Card.Footer className='text-right' style={{ fontSize: 10, fontStyle: "italic" }}>
                    Atualizado em: {new Date().toLocaleDateString('pt-BR')}
                  </Card.Footer>
                </Card>
              </Col>
            </Row>
          )
        })
        }

        <Modal show={showModal} onHide={onCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title style={{ display: 'flex', flexDirection: 'column' }}>
              <span>
                Audiências Públicas
              </span>
              <span style={{ fontSize: 16, fontWeight: 100 }}>
                {modalData.nome}
              </span>

            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th className="text-center">Evento</th>
                  <th className="text-center">Data</th>
                  <th>Edital</th>
                </tr>
              </thead>
              <tbody>
                {
                  modalData.audiencias && modalData.audiencias.map((audi, i) => {
                    return (
                      <tr key={i}>
                        <td>{audi[1]}</td>
                        <td className="text-center">{audi[2]}</td>
                        <td className="text-center"><a href={audi[6]} target="_blank" rel="noreferrer">Acessar </a></td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={onCloseModal}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showModalRotas} onHide={onCloseModalRotas}>
          <Modal.Header closeButton>
            <Modal.Title style={{ display: 'flex', flexDirection: 'column' }}>
              <span> Rotas </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              modalDataRotas && modalDataRotas.map((rota, i) => {
                return (
                  <>
                    <p style={{ marginBottom: 0 }}><b>Nome da Rota:</b> {rota.nome}</p>
                    <p style={{ marginBottom: 0 }}><b>Sentido:</b> {rota.sentido}</p>
                    <p style={{ marginBottom: 0 }}><b>Zona Responsável:</b> {rota.num_zona_resp}</p>
                    <Table striped bordered hover style={{ marginBottom: 30 }}>
                      <thead>
                        <tr>
                          <th className="text-center">Local de Votação</th>
                          <th className="text-center">Horário Distribuição</th>
                          <th className="text-center">Horário Coleta</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          rota.rotas && rota.rotas.map((aa, b) => {
                            return (
                              <tr key={'a' + b}>
                                <td>{aa.local}</td>
                                <td className="text-center">{aa.coleta}</td>
                                <td className="text-center">{aa.distribuicao}</td>
                              </tr>
                            )
                          })
                        }
                      </tbody>
                    </Table>
                  </>
                )
              })
            }
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={onCloseModalRotas}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>

      </Container>
    </>
  );
}

export default Gpr;